module.exports = __webpack_public_path__ + "static/media/marketing-digital-quito-fundacion-avina.7a8d3be6.jpg";